<template>
  <div class="home">
    <h1>NetfliQs</h1>
    <p>Video's met impact</p>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>

.home {
  margin: 50px
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue